module.exports = __webpack_public_path__ + "static/media/4.2fa9df6c.JPG";